var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="container"> <ul class="nav page-navigation"> <li class="nav-item mr-auto"> <a class="nav-link" href="index.html#index"> <span class="menu-title">'+
((__t=( resources['X200017'] ))==null?'':__t)+
'</span> </a> </li> <li class="nav-item ml-auto"> <a class="nav-link" href="#register"> <span class="menu-title">'+
((__t=( resources['X200183'] ))==null?'':__t)+
'</span> </a> </li> <li class="nav-item" id="menu_btnForgotPassword"> <a class="nav-link" href="#btnForgotPassword"> <span class="menu-title">'+
((__t=( resources['X200020'] ))==null?'':__t)+
'</span> </a> </li> <li class="nav-item" id="menu_btnAuthLogoff"> <a class="nav-link" href="#btnAuthLogoff"> <span class="menu-title">'+
((__t=( resources['X200014'] ))==null?'':__t)+
'</span> </a> </li> <li class="nav-item" id="menu_btnAuth"> <a class="nav-link" style="cursor:pointer"> <span class="menu-title">'+
((__t=( resources['X200019'] ))==null?'':__t)+
'</span> </a> </li> <li class="nav-item" id="menu_btnAuthPortal"> <a class="nav-link" href="portal.html"> <span class="menu-title">'+
((__t=( resources['X200018'] ))==null?'':__t)+
'</span> </a> </li> </ul> </div>';
}
return __p;
};
